import { render, staticRenderFns } from "./cjwt.vue?vue&type=template&id=1ecdbd4c&scoped=true&"
import script from "./cjwt.vue?vue&type=script&lang=js&"
export * from "./cjwt.vue?vue&type=script&lang=js&"
import style0 from "./cjwt.vue?vue&type=style&index=0&id=1ecdbd4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecdbd4c",
  null
  
)

export default component.exports